export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.293 20c-3.922 0-7.112-2.512-8.15-6.047h-.889v5.779H5.707V4h5.984c.933 0 1.753.13 2.461.39.708.259 1.3.613 1.774 1.061.475.448.829.972 1.061 1.568a5.21 5.21 0 01.35 1.91c0 1.023-.229 1.915-.688 2.678-.458.763-1.105 1.303-1.942 1.76a3.762 3.762 0 01-1 .413c.82 1.727 2.473 2.865 4.586 2.865V20zm-6.708-8.784c.675 0 1.206-.196 1.592-.59.386-.392.58-.888.58-1.485 0-.645-.194-1.156-.58-1.534-.386-.377-.917-.566-1.592-.566H9.41v4.175h2.175z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};